module.exports = __webpack_public_path__ + "img/icon_arrow_up_brown.8e1812a7.svg";